// Robust in-page smooth scroll that self-corrects for late layout shifts
// (e.g. lazy images loading and growing page height mid-scroll).
export const scrollToHash = (href) => {
  if (!href || !href.startsWith("#")) return;
  const doScroll = () => {
    if (href === "#home") {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    const el = document.getElementById(href.slice(1));
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  // Re-run a few times so the final alignment is correct once content settles.
  [0, 240, 500, 820, 1200].forEach((t) => setTimeout(doScroll, t));
};
